// Id   Type  Priority  Name
// 7    1     3         Pass
// 8    2     3         Retro Date Inception
// 9    3     3         Retro Date Unlimited
// 10   4     3         Additional Question
// 11   1     2         Refer
// 12   1     1         Decline

// Enum representing different question statuses
export enum QuestionStatus {
    Pass = 7,
    RetroDateInception = 8,
    RetroDateUnlimited = 9,
    AdditionalQuestion = 10,
    Refer = 11,
    Decline = 12
}

// An object that maps QuestionStatus values to corresponding actions
const actions = {
    [QuestionStatus.Pass]: {type: 1, priority: 3, name: "Pass"},
    [QuestionStatus.RetroDateInception]: {type: 2, priority: 3, name: "Retro Date Inception"},
    [QuestionStatus.RetroDateUnlimited]: {type: 3, priority: 3, name: "Retro Date Unlimited"},
    [QuestionStatus.AdditionalQuestion]: {type: 4, priority: 3, name: "Additional Question"},
    [QuestionStatus.Refer]: {type: 1, priority: 2, name: "Refer"},
    [QuestionStatus.Decline]: {type: 1, priority: 1, name: "Decline"},
}

export const DecisionTreeOptionAction = actions;